/**
 * Copyright © Ircam Amplify 2024-2026
 */

import { signOutUser } from '@/pages/Login/Login'
import { getUserState, useSelector } from '@/store'
import { getCurrentUser, signOut } from 'aws-amplify/auth'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'

export default function RequiresAuth({ children }: { children: any }) {
  const navigate = useNavigate()
  const location = useLocation()

  const [userChecked, setUserChecked] = useState(false)
  const { userInfo } = useSelector(getUserState)

  useEffect(() => {
    const checkUser = async () => {
      try {
        const usr = await getCurrentUser()
        if (!usr) {
          await signOut()
          signOutUser()
          navigate('/login')
        }
      } catch {
        await signOut()
        signOutUser()
        navigate('/login', { state: { from: location.pathname } })
      }
      setUserChecked(true)
    }
    checkUser()
  }, [Boolean(userInfo?.user_cognito_id), location, navigate])

  if (userChecked) {
    return children
  }
}
